import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { IFetchPathwaysAction, PathwaysActionTypes } from "./pathwaysTypes"

export const fetchPathwaysAction = (searchQuery: ISearchQuery): IFetchPathwaysAction => {
  return {
    type: PathwaysActionTypes.FETCH_PATHWAYS_ASYNC_PENDING,
    payload: searchQuery
  }
}
